import { cancelToken, get, getQueryParams } from '@fareye/utils'
import React, { useEffect, useState } from 'react'
import {
  HEADER_INFLECTION,
  initialState,
  DEFAULT_POI_COLUMNS,
  DEFAULT_POI_FORM_RENDERING,
  POI_CONFIG
} from '../../../config/constants'
import { Button, Flex, RenderControl, Table } from '@fareye/ui'
import { getTableColumns } from '../components/Column'
import { useTranslation } from '@fareye/common'
import PoiModal from '../components/PoiModal'

export default function DefaultPoiConfig({ match }: any) {
  const {
    params: { userId }
  } = match
  const source = cancelToken().source()
  const [reloadPoi, setReloadPoi] = useState(0)
  const [poiData, setPoiData] = useState(initialState)
  let { defaultPoiConfig } = POI_CONFIG
  const { t } = useTranslation()
  const [selectedPoi, setSelectedPoi] = useState({
    data: {},
    action: 'add',
    openModal: false
  })

  useEffect(() => {
    if (userId) {
      fetchPoiData(userId)
    }
  }, [userId])

  async function fetchPoiData(userId: string) {
    try {
      setPoiData({ ...poiData, isLoading: true })
      const queryParam = getQueryParams({ userId })
      let url = `${defaultPoiConfig}?${queryParam}`
      const {
        data: { content }
      } = await get(url, source.token, HEADER_INFLECTION)
      setPoiData({
        ...poiData,
        data: content,
        isLoading: false,
        isError: false,
        message: ''
      })
    } catch (error) {
      setPoiData({
        ...poiData,
        isLoading: false,
        isError: true,
        message: 'Something went wrong'
      })

      console.error(error)
    }
  }

  return (
    <Flex style={{ padding: '20px' }} column>
      <Flex alignItemsCenter justifyContentSpaceBetween>
        <h3>Default Poi Config for User - {userId}</h3>
        <Flex>
          <Button
            variant="primary"
            mr={4}
            onClick={() => {
              setSelectedPoi({
                data: {userId: userId},
                action: 'add',
                openModal: true
              })
            }}
          >
            Add Default Poi
          </Button>
        </Flex>
      </Flex>
      <RenderControl state={poiData}>
        <Table
          className="striped responsive"
          columns={getTableColumns(DEFAULT_POI_COLUMNS, {
            t,
            setSelectedPoi
          })}
          data={poiData.data}
          size="xs"
          showTotalCount={false}
          sortable
          defaultPageSize={20}
          dataLoading={poiData.isLoading}
          totalElements={poiData.data?.length}
          />
      </RenderControl>
      <PoiModal selectedPoi={selectedPoi} setSelectedPoi={setSelectedPoi} />
    </Flex>
  )
}
